<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Dog'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteDog">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteDogDialog",
  emits: ["deleteDog"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      dog: null,
      dogId: null,
      name: null,
    };
  },
  methods: {
    show(dog) {
      (async () => {
        this.dog = dog;
        this.name = dog.name;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteDog() {
      this.$emit("deleteDog", this.dog);
    },
  },
};
</script>
